{
    "header": {
        "language": "Language",
        "logout": "Logout"
    },
    "languages": {
        "en": "English",
        "nl": "Dutch"
    }
}
